import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "rounded-xl hide-scrollbar",
  style: {"height":"calc(97vh - 140px)","overflow-y":"auto","background":"white"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceHtmlTemplateView = _resolveComponent("InvoiceHtmlTemplateView")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_InvoiceThemeMenu = _resolveComponent("InvoiceThemeMenu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pb-0",
    style: {"background-color":"#f4f4f4 !important","border-radius":"12px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "mt-0 ml-1 mb-0 pb-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "py-2 hide-scrollbar",
            style: {"height":"calc(97vh - 140px)","overflow-y":"auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InvoiceHtmlTemplateView, {
                invoiceThemeSettings: _ctx.updatedSettings,
                invoiceData: _ctx.invoiceSample,
                quotation: _ctx.quotationSample,
                forPrint: false,
                company: _ctx.company,
                backgroundImage: _ctx.backgroundImage,
                additionalDocument: _ctx.additionalDocument,
                additionalDocumentId: _ctx.additionalDocumentId,
                editedElementClass: _ctx.editedElementClass
              }, null, 8, ["invoiceThemeSettings", "invoiceData", "quotation", "company", "backgroundImage", "additionalDocument", "additionalDocumentId", "editedElementClass"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "py-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_InvoiceThemeMenu, {
                  companyId: _ctx.companyId,
                  initialInvoiceThemeSettings: _ctx.invoiceThemeSettings,
                  idTheme: _ctx.idTheme,
                  onUpsertInvoiceTheme: _ctx.upsertInvoiceTheme,
                  onPdfPreview: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPDFPreview())),
                  onBackgroundImage: _cache[1] || (_cache[1] = (imageData) => _ctx.handleImageBackground(imageData)),
                  onAdditionalDocument: _cache[2] || (_cache[2] = (docData) => _ctx.handleAdditionalDocument(docData)),
                  onEditing: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editing($event))),
                  onThemeSelected: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleThemeSelected($event))),
                  onResetPersonalized: _ctx.handlePersonalizedThemeReset,
                  onDocumentTypeSelected: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleDOcumentTypeSelected($event))),
                  onSettingsChange: _ctx.handleSettingsChange,
                  onChangedLegalFormInfo: _ctx.onLegalFormInfoChanged
                }, null, 8, ["companyId", "initialInvoiceThemeSettings", "idTheme", "onUpsertInvoiceTheme", "onResetPersonalized", "onSettingsChange", "onChangedLegalFormInfo"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}